import Accueil from "../../../../src/composants/accueil/accueil";
import * as React from 'react';
export default {
  Accueil,
  React
};